import { useAuthApi } from '..';

export function useAuthForgotPasswordApi() {
  const { post } = useAuthApi();

  return {
    post: (emailAddress: string): Promise<boolean> => post('user/forgot-password', {
      emailAddress,
    }),
  };
}
